var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerKickTaken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.38,28.49H28.31V4.16a15.07,15.07,0,0,1,5.44-.78c2.61.11,3.78.88,6.46,1.19a18.71,18.71,0,0,0,6.38-.41V15.47a18.71,18.71,0,0,1-6.38.41c-2.68-.31-3.85-1.08-6.46-1.19a15.07,15.07,0,0,0-5.44.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.48,4V9.69A15.52,15.52,0,0,0,33.77,9a15,15,0,0,0-5.43.79V4.16a14.79,14.79,0,0,1,5.43-.78A15,15,0,0,1,37.48,4Z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 28.31,
    y1: 28.49,
    x2: 37.94,
    y2: 46.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.53,28.49a16.66,16.66,0,0,0,5.81,6.18,16.92,16.92,0,0,0,10.53,2.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.62,9.82v5.65a18.5,18.5,0,0,1-6.39.41,21.76,21.76,0,0,1-2.75-.53V9.69a20,20,0,0,0,2.75.54A19,19,0,0,0,46.62,9.82Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8.61,
    cy: 19.46,
    r: 4.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.47,
    y1: 24.42,
    x2: 18.5,
    y2: 25.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.2,
    y1: 18.43,
    x2: 20.23,
    y2: 19.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.05,
    y1: 21.92,
    x2: 21.08,
    y2: 23.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerKickTaken);
export default __webpack_public_path__ + "static/media/CORNER_KICK_TAKEN.7f62f671c7ba9a1303e5eeaacbf3901c.svg";
export { ForwardRef as ReactComponent };